exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-2fa33ed8]{height:42px;line-height:42px}.item.is-selected[data-v-2fa33ed8]{position:relative}.is-selected[data-v-2fa33ed8]:after{content:\"\";position:absolute;background-color:var(--black-light-2);width:calc(100% + 48px);height:100%;left:-24px;z-index:-1}", ""]);

// exports
